import React from 'react';

interface SectionSeparatorProps {
    children: React.ReactNode;
    className?: string;
}

const SectionSeparator: React.FC<SectionSeparatorProps> = ({ children, className = '' }) => {
    return (
        <div className={`space-y-4 pb-4 border-b border-neutral-400 dark:border-neutral-700 ${className}`}>
            {children}
        </div>
    );
};

export default SectionSeparator;